module.exports = __webpack_public_path__ + "static/social-c10922a8b45fef2e3fa042179efd5511.png";